import React from 'react';

import { Spacer, Text } from '@ontruck/orc';

const t = {
  chat: 'Chat',
};

const ChatRenderer = ({ changes: { chat }, ...props }) => {
  return (
    <Spacer {...props}>
      <Text color="grey800" display="block">
        {`${t.chat}: ${chat}`}
      </Text>
    </Spacer>
  );
};

export default ChatRenderer;
